import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import BackBtn from '../../common/backBTN';

function MobileAccount({userData, sociallink, general, refreshPrivateData}){
  
    const [modal, setModal] = useState(false);
      const [isRefreshing, setIsRefreshing] = useState(false);
    const navigate = useNavigate();
    const [selectedBrand, setSelectedBrand] = useState('localhost');

  
    // Logout function
    const logout = () => {
        localStorage.removeItem('token');
        localStorage.removeItem('balance');
        localStorage.removeItem('remote_id');
        localStorage.removeItem('username');
        localStorage.removeItem('exchangeToken');
        localStorage.removeItem('agent_code');
        window.location.href = '/home';
    };
const handleRefreshBalance = async () => {
  setIsRefreshing(true);
    if (!refreshPrivateData || isRefreshing) return;
    try {
     
      setIsRefreshing(true);
      await refreshPrivateData();
    } catch (err) {
      console.error('Error refreshing balance:', err);
    } finally {
      console.log('Finished refreshing balance');
      setTimeout(() => setIsRefreshing(false), 800);
    }
  };
   const handleChatClick = (e) => {
        e.preventDefault();
		  // brodcast event to open chat
		  window.dispatchEvent(new CustomEvent('open_chat', { detail: { foo: 'bar' } }));
      };
      const origin = window.location.origin.replace(/^https?:\/\/(www\.)?/, '').replace(/(\.com|\.live|\.net|\.world)$/i, '');

    // Copy helper
    const copyToClipboard = (text, label = 'Text') => {
      try {
        const value = text ?? '';
        if (!value) return;
        if (navigator?.clipboard?.writeText) {
          navigator.clipboard.writeText(String(value));
          alert(`${label} copied!`);
        } else {
          const ta = document.createElement('textarea');
          ta.value = String(value);
          ta.style.position = 'fixed';
          ta.style.opacity = '0';
          document.body.appendChild(ta);
          ta.select();
          document.execCommand('copy');
          document.body.removeChild(ta);
          alert(`${label} copied!`);
        }
      } catch (e) {
        console.error('Copy failed', e);
      }
    };

    useEffect(() => {
    const hostname = (window.location.hostname || '').toLowerCase();
    const origin = (window.location.origin || '').toLowerCase();
    const search = (window.location.search || '').toLowerCase();
    const params = new URLSearchParams(window.location.search);
    const brand = ((process.env.REACT_APP_BRAND || localStorage.getItem('brand') || '')).toLowerCase();

    const isBeetbuzz = hostname.includes('beetbuzz') || origin.includes('beetbuzz') || brand.includes('beetbuzz');
    const isLocalhost = hostname.includes('localhost') || origin.includes('localhost') || brand.includes('localhost');
    const isBk8bd = hostname.includes('bk8bd') || origin.includes('bk8bd') || brand.includes('bk8bd');
    const isCb444 = hostname.includes('cb444') || origin.includes('cb444') || brand.includes('cb444');
    const isjw88 = hostname.includes('jw88') || origin.includes('jw88') || brand.includes('jw88');
    const isCk4 = hostname.includes('ck4') || origin.includes('ck4') || brand.includes('ck4');
    const isSk444 = hostname.includes('sk444') || origin.includes('sk444') || brand.includes('sk444');
    const isKrikiya = hostname.includes('krikiya') || origin.includes('krikiya') || brand.includes('krikiya');

    const selectedBrand = isSk444 ? 'sk444': isCk4 ? 'ck4' : isjw88 ? 'jw88' : isKrikiya ? 'krikiya' : isBeetbuzz ? 'beetbuzz' : isLocalhost ? 'localhost' : (isBk8bd || isCb444) ? 'bk8bd' : 'default';

    localStorage.setItem('brand', selectedBrand);
    setSelectedBrand(selectedBrand);
  
    
  
  
   
  }, []);



    return(
        <div id="mc-animate-container" className="v-base v-detail-base fade-enter-done">
  <div id="mc-app-home-root" className="mc dark">
    <div className="mc-header-wrap">
      <div id="mc-header" className="mc-navbar-blue mc-home mc-default-header am-navbar am-navbar-light">
        <Link to={"/home"} className="am-navbar-left" role="button">
        <span className="am-navbar-left-content">
          <span className="return_icon">
            <svg className="am-icon am-icon-left am-icon-lg">
              <use xlinkHref="#left" />
            </svg>
          </span>
        </span>
      </Link>
        <div className="am-navbar-title">My Account</div>
        <div className="am-navbar-right" />
      </div>
      <div className="am-whitespace am-whitespace-sm mc-whitespace" />
    </div>
    <div className="n-home-container">
      <div className="n-home-header">
        <div className="default-member-wrapper" style={{background: '#1a2e2a'}}>
          <div className="default-vip-icon"><img src="/icons/reward/icon-vip-badge.svg" alt="VIP" /></div>
         {selectedBrand !== 'beetbuzz' && (
            <div className="cumulative-sign-in"><Link href="/m/activity/signIn">Sign In</Link></div>
          )}
          
          <div className="default-member-header">
            <div className="profile-icon">
              <img src="https://images.394993282.com//TCG_PROD_IMAGES/B2C/01_PROFILE/PROFILE/0.png" alt="" />
              {/* react-empty: 7331 */}
            </div>
            <div className="member-info">
              <div className="vip-tag">
                <div className="vip-img"><img src="/icons/reward/icon-vip-badge.svg" alt="VIP" /></div>
                <div className="vip-name">VIP0</div>
              </div>
              <div className="account-wrapper" style={{display:'flex', alignItems:'center', gap:6}}>
                {/* <span>{userData ? userData.name : 'User'}</span>
                <span
                  role="button"
                  aria-label="Copy name"
                  onClick={() => copyToClipboard(userData?.name || '', 'Name')}
                  style={{cursor:'pointer', display:'inline-flex'}}
                >
                  <svg className="am-icon am-icon-icon-copy_17d4102f am-icon-md"><use xlinkHref="#icon-copy_17d4102f" /></svg>
                </span> */}
              </div>
              <div className="nickname-wrapper">
                <div className="nickname-info">
                  <span className="info-title">
                    {/* react-text: 7178 */}Username{/* /react-text */}{/* react-text: 7179 */}:
                    {/* /react-text */}
                  </span>
                  <span className="name-text" style={{display:'inline-flex', alignItems:'center', gap:6}}>
                    {userData?.username || 'Nickname'}
                    <span
                      role="button"
                      aria-label="Copy username"
                      onClick={() => copyToClipboard(userData?.username || '', 'Username')}
                      style={{cursor:'pointer', display:'inline-flex'}}
                    >
                      <svg className="am-icon am-icon-icon-copy_17d4102f am-icon-md"><use xlinkHref="#icon-copy_17d4102f" /></svg>
                    </span>
                  </span>
                </div>
                {/* <Link className="go-to-edit" href="/m/myAccount/nickName">
                  <svg className="am-icon am-icon-icon-edit_68c0ffef am-icon-md"><use xlinkHref="#icon-edit_68c0ffef" /></svg>
                </Link> */}
              </div>
            </div>
          </div>
          <div className="default-member-mid">
            <div className="amount-balance-common current-wallet">
              <span className="currency">৳</span>
              {/* react-text: 7187 */}&nbsp;{/* /react-text */}
              <span className="number-mc undefined">{userData?.balance || 0}</span>
            </div>
            <div onClick={handleRefreshBalance} className={`refresh-btn`}>
              <svg className={`am-icon am-icon-refresh_e506c375 am-icon-md refresh-balance ${isRefreshing ? 'loading' : ''}`} ><use xlinkHref="#refresh_e506c375" /></svg>
            </div>
          </div>
          <div className="default-member-footer-wrapper">
            <div className="member-arrow" />
            <div className="default-member-footer-wrap">
              <div className="default-member-footer equal">
                <Link className="footer-item" rel="nofollow me noopener noreferrer" to={"/deposit"}><span>Deposit</span></Link>
                <Link rel="nofollow me noopener noreferrer" className="footer-item" to={"/withdraw"}>Withdrawal</Link> 
                
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="member-home-root" style={{minHeight: 'calc(-287.917px + 100vh)'}}>
        <div>
          <div className="n-nav-list-title"><span>Member Center</span></div>
          <div className="mc-flex mc-flex-between mc-flex-row main-nav-list">
            <Link to="/rewardcenter" className="REWCEN3 main-nav-style mcm-teampandect">
              <div className="n-linear-border">
                <div>
                  <svg className="am-icon am-icon-AGETEAMPNL3_a62d89c9 am-icon-lg"><use xlinkHref="#AGETEAMPNL3_a62d89c9" /></svg>
                  {/* <div className="un-read-count">2</div> */}
                </div>
              </div>
              <br />
              <span className="main-text">Reward Center</span>
            </Link>
            <Link to={"/bettingRecord"} className="TRANSBETREPMEM3 main-nav-style mcm-teampandect">
              <div className="n-linear-border">
                <div>
                  <svg className="am-icon am-icon-TRANSBETREPMEM3_0d83fc3f am-icon-lg"><use xlinkHref="#TRANSBETREPMEM3_0d83fc3f" /></svg>
                </div>
              </div>
              <br />
              <span className="main-text">Betting Record</span>
            </Link>
            <Link to={"/profitandloss"} className="PERSPNL3 main-nav-style mcm-teampandect">
              <div className="n-linear-border">
                <div>
                  <svg className="am-icon am-icon-PERSREP_9e354430 am-icon-lg"><use xlinkHref="#PERSREP_9e354430" /></svg>
                </div>
              </div>
              <br />
              <span className="main-text">Profit And Loss</span>
            </Link>
            <Link to={"/depositRecord"} className="DEPRECM3 main-nav-style mcm-teampandect">
              <div className="n-linear-border">
                <div>
                  <svg className="am-icon am-icon-deposit_record_b99e1f01 am-icon-lg"><use xlinkHref="#deposit_record_b99e1f01" /></svg>
                </div>
              </div>
              <br />
              <span className="main-text">Deposit Record</span>
            </Link>
            <Link to={"/withdrawRecord"} className="WITHREC3 main-nav-style mcm-teampandect">
              <div className="n-linear-border">
                <div>
                  <svg className="am-icon am-icon-withdraw_record_c986adfb am-icon-lg"><use xlinkHref="#withdraw_record_c986adfb" /></svg>
                </div>
              </div>
              <br />
              <span className="main-text">Withdrawal Record</span>
            </Link>
            <Link to={"/mission"} className="TURNOVER main-nav-style mcm-teampandect">
              <div className="n-linear-border">
                <div>
                  <svg className="am-icon am-icon-FEEDBACK3_df31c81c am-icon-lg"><use xlinkHref="#FEEDBACK3_df31c81c" /></svg>
                </div>
              </div>
              <br />
              <span className="main-text">Turnover</span>
            </Link>
            <Link to={"/transactionRecord"} className="TRANSREC3 main-nav-style mcm-teampandect">
              <div className="n-linear-border">
                <div>
                  <svg className="am-icon am-icon-TRANSREC3_fcac856d am-icon-lg"><use xlinkHref="#TRANSREC3_fcac856d" /></svg>
                </div>
              </div>
              <br />
              <span className="main-text">Account Record</span>
            </Link>
            <Link to={"/personalInformation"} className="MYACC main-nav-style mcm-teampandect">
              <div className="n-linear-border">
                <div>
                  <svg className="am-icon am-icon-MYACC_a7ef046a am-icon-lg"><use xlinkHref="#MYACC_a7ef046a" /></svg>
                </div>
              </div>
              <br />
              <span className="main-text">My Account</span>
            </Link>
            <Link to={"/securityCenter"} className="SECPRIV main-nav-style mcm-teampandect">
              <div className="n-linear-border">
                <div>
                  <svg className="am-icon am-icon-SECPRIV_3f9a598c am-icon-lg"><use xlinkHref="#SECPRIV_3f9a598c" /></svg>
                </div>
              </div>
              <br />
              <span className="main-text">Security Center</span>
            </Link>
            <Link to={"/referral"} className="REFERRAL main-nav-style mcm-teampandect">
              <div className="n-linear-border">
                <div>
                  <svg className="am-icon am-icon-REFERRAL_9586116f am-icon-lg"><use xlinkHref="#REFERRAL_9586116f" /></svg>
                </div>
              </div>
              <br />
              <span className="main-text">Invite Friends</span>
            </Link>
            <Link to={"/mission"} className="MISSIONLB3 main-nav-style mcm-teampandect">
              <div className="n-linear-border">
                <div>
                  <svg className="am-icon am-icon-gift_d78de60c am-icon-lg"><use xlinkHref="#gift_d78de60c" /></svg>
                  {/* <div className="un-read-count">1</div> */}
                </div>
              </div>
              <br />
              <span className="main-text">Mission</span>
            </Link>
            <Link to={"/rebateBonus"} className="MANPLAYREB3 main-nav-style mcm-teampandect">
              <div className="n-linear-border">
                <div>
                  <svg className="am-icon am-icon-MANPLAYREB3_da78e50e am-icon-lg"><use xlinkHref="#MANPLAYREB3_da78e50e" /></svg>
                </div>
              </div>
              <br />
              <span className="main-text">Manual Rebate</span>
            </Link>
            <Link to={"/inbox"} className="MAILCEN main-nav-style mcm-teampandect">
              <div className="n-linear-border">
                <div>
                  <svg className="am-icon am-icon-MAILCEN_4962dbe3 am-icon-lg"><use xlinkHref="#MAILCEN_4962dbe3" /></svg>
                  {/* <div className="un-read-count">3</div> */}
                </div>
              </div>
              <br />
              <span className="main-text">Internal Message</span>
            </Link>
            <a  href={`./app/${origin}.apk`} className="APPDOWNLOAD main-nav-style mcm-teampandect">
              <div className="n-linear-border">
                <div>
                  <svg className="am-icon am-icon-APPDOWNLOAD_44ccdfbb am-icon-lg"><use xlinkHref="#APPDOWNLOAD_44ccdfbb" /></svg>
                </div>
              </div>
              <br />
              <span className="main-text">Download APP</span>
            </a>
            <a  onClick={handleChatClick} className="OPENHOURSSERVE main-nav-style mcm-teampandect">
              <div className="n-linear-border">
                <div>
                  <svg className="am-icon am-icon-open_hours_141ce365 am-icon-lg"><use xlinkHref="#open_hours_141ce365" /></svg>
                </div>
              </div>
              <br />
              <span className="main-text">Customer Service</span>
            </a>
            <div className="LOGOUT main-nav-style mcm-teampandect"  onClick={() => setModal(true)}>
              <div className="n-linear-border">
                <div>
                  <svg className="am-icon am-icon-logout_bfa9feaf am-icon-lg"><use xlinkHref="#logout_bfa9feaf" /></svg>
                </div>
              </div>
              <br />
              <span className="main-text">Logout</span>
            </div>
          </div>
          <div className="mc-flex mc-flex-between mc-flex-row main-nav-list" />
        </div>
      </div>
    </div>
    
  </div>
  <div>
    
    {modal && (
      <>
  <div  onClick={() => setModal(false)} className="am-modal-mask" />
  <div tabIndex={-1} className="am-modal-wrap" role="dialog" aria-labelledby="rcDialogTitle0">
    <div role="document" className="am-modal am-modal-transparent" style={{width: '5.4rem', height: 'auto'}}>
      <div className="am-modal-content">
        <div className="am-modal-header"><div className="am-modal-title" id="rcDialogTitle0">Confirmation</div></div>
        <div className="am-modal-body">
          <div style={{zoom: 1, overflow: 'hidden'}}><div className="change-modal-title">Are you sure you want to logout?</div></div>
        </div>
        <div className="am-modal-footer">
          <div className="am-modal-button-group-h am-modal-button-group-normal" role="group"><Link  onClick={() => setModal(false)} className="am-modal-button" role="button">Cancel</Link><Link onClick={logout} className="am-modal-button" role="button">OK</Link></div>
        </div>
      </div>
      <div tabIndex={0} style={{width: '0px', height: '0px', overflow: 'hidden'}}>sentinel</div>
    </div>
  </div>
</>
  )}
 
  
</div>


</div>

    );
}
export default MobileAccount;